import React from "react";

export type TAccountDetalizationContainerContext = {
  runReprocess: (args: { fromDate: string; toDate: string; subscribers: string[] }) => void;
};

export const AccountDetalizationContainerContext = React.createContext<TAccountDetalizationContainerContext | null>(
  null
);

export const useAccountDetalizationContainerContext = () =>
  React.useContext(AccountDetalizationContainerContext);
